import { errorTextColor, infoTextColor, warningTextColor } from '../../common/constants';
import { AlarmLevel } from '../../models';

export interface ILogbookEntryHelper {
    logbookEntryLevelColor(level: AlarmLevel): string;
}

export class LogbookEntryHelper implements ILogbookEntryHelper {
    static helperId = 'logbookEntryHelper';
    
    logbookEntryLevelColor(level: AlarmLevel): string {
        const warningOrInfo = level === AlarmLevel.Warning ? warningTextColor : infoTextColor;
        return level === AlarmLevel.Critical ? errorTextColor : warningOrInfo;
    }
}